module.exports = __webpack_public_path__ + "img/OVO_120X35.1c7abef0.png";